export const SET_LOG_IN = "SET_LOG_IN";
export const SET_LOG_OUT = "SET_LOG_OUT";
export const FIRST_CHECK_DONE = "AUTH_FIRST_CHECK_DONE";
export const SET_VERIFICATION_EMAIL_SENT_DIALOG_OPEN =
  "SET_VERIFICATION_EMAIL_SENT_DIALOG_OPEN";
export const SET_EMAIL_VERIFICATION_STATUS = "SET_EMAIL_VERIFICATION_STATUS";
export const SET_GLOBAL_AUTHORIZATION = "SET_GLOBAL_AUTHORIZATION";
export const SET_RESOURCE_AUTHORIZATION = "SET_RESOURCE_AUTHORIZATION";
